import React, { FC } from 'react';
import {
  NotificationsProvider,
  ThemeProvider as MUIThemeProvider,
} from '@prometheus/components';
import { DialogProvider, ModalProvider } from '@prometheus/hooks';
import { theme } from './utils/theme';
import { ThemeProvider } from '@emotion/react';

export const Providers: FC<any> = props => {
  const { children } = props;

  return (
    <MUIThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <NotificationsProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <DialogProvider>{children}</DialogProvider>
        </NotificationsProvider>
      </ThemeProvider>
    </MUIThemeProvider>
  );
};
